import { memo, type FC, type ReactNode } from "react";
import { Plus } from "lucide-react";

interface ChoiceCardProps {
  title: string;
  selected: boolean;
  onSelect: () => void;
  description?: string;
  isCustom?: boolean;
  children?: ReactNode;
}

const ChoiceCard: FC<ChoiceCardProps> = ({
  title,
  selected,
  onSelect,
  description,
  isCustom = false,
  children,
}) => (
  <div
    className={`choice-card ${selected ? "choice-card--selected" : ""} ${
      isCustom ? "choice-card--custom" : ""
    }`}
  >
    <button
      type="button"
      role="radio"
      aria-checked={selected}
      className="choice-card__trigger"
      onClick={onSelect}
    >
      {isCustom ? (
        <Plus className="choice-card__plus" aria-hidden />
      ) : (
        <span className="choice-card__radio" aria-hidden />
      )}
      <span className="choice-card__text">
        <span className="choice-card__title">{title}</span>
        {description && <span className="choice-card__description">{description}</span>}
      </span>
    </button>
    {selected && children && <div className="choice-card__panel">{children}</div>}
  </div>
);

export default memo(ChoiceCard);
